import { BaseIcon, BaseIconProps } from '../../atoms/BaseIcon';
import React from 'react';

export const ChevronDown = ({ dataTestId = 'icon-ChevronDown', ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} dataTestId={dataTestId}>
    <g fillRule="evenodd">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 13.586L6.707 8.293a1 1 0 00-1.414 1.414l6 6a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414z" />
    </g>
  </BaseIcon>
);
